import React, { useRef } from 'react'
import { FieldProps } from 'formik'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'
import { getYear, getMonth } from 'date-fns'
import { ja } from 'date-fns/locale'
import 'react-datepicker/dist/react-datepicker.css'
import { FormControl } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { dateTimeToString, stringToDateTime } from 'common/generalUtil'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& .react-datepicker-wrapper': {
      flex: '1 0 0',
      marginRight: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
    },
    '& .react-datepicker__navigation': {
      top: '13px'
    }
  },
  inputField: {
    width: '250px',
    minHeight: '40px',
    maxHeight: '40px',
    padding: '0px 20px 0 8px',
    background: 'none #fff',
    border: '1px solid #8593a6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    cursor: 'pointer',
    lineHeight: '30px',
  },
  // MCBリプレイス #8676 START
  errorBorder: {
    border: '1px solid #e53935 !important',
  },
  // MCBリプレイス #8676 END
}))

export const useErrorStyle = makeStyles({
  helperText: {
    marginTop: '2px',
    background: 'none #fff',
    fontSize: '11px',
    color: 'red',
    whiteSpace: 'pre-wrap',
  },
})

interface Props extends FieldProps, ReactDatePickerProps {
  className?: string
  changeState: Function
}

export default ({
  className,
  form,
  field,
  changeState,
  onChange,
  ...otherProps
}: Props) => {
  const classes = useStyles()
  const { name, value } = field
  const { errors, touched } = form
  const inputRef = useRef<DatePicker>(null)
  const errorclasses = useErrorStyle()

  const handleChange = (date: Date | null) => {
    // 維持保守 #9483 start
    var a = dateTimeToString(date)
    form.setFieldValue(name, a)
    // 維持保守 #9483 end
  }

  const handleIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.setFocus()
    }
  }

  let optionProps = {}

  if (otherProps.selectsStart) {
    optionProps = {
      startDate: form.values.startDate,
      endDate: form.values.endDate,
    }
  }

  if (otherProps.selectsEnd) {
    optionProps = {
      startDate: form.values.startDate,
      endDate: form.values.endDate,
      minDate: form.values.startDate,
    }
  }

  return (
    <FormControl>
      <div className={`${classes.root} ${className}`}>
        <DatePicker
          name={name}
          // MCBリプレイス #8676 START
          className={
            errors[name] && touched[name]
              ? `${classes.inputField} ${classes.errorBorder}`
              : classes.inputField
          }
          // MCBリプレイス #8676 END
          showTimeSelect
          // 維持保守 #91716 start
          timeFormat='HH:00'
          timeIntervals={60}
          dateFormat='yyyy/MM/dd HH:00'
          locale={ja}
          ref={inputRef}
          placeholderText='YYYY/MM/DD HH:00'
          // 維持保守 #91716 end
          // MCBリプレース MCBJS020 START
          selected={isNaN(Date.parse(value)) ? null : stringToDateTime(value)}
          // MCBリプレース MCBJS020 END          
          onChange={handleChange}
          timeCaption="時間"
          renderCustomHeader={({ 
            date,
            decreaseMonth,
            increaseMonth,
            prevMonthButtonDisabled,
            nextMonthButtonDisabled
          }) => (
            <div>
              <button 
                type="button" 
                className="react-datepicker__navigation react-datepicker__navigation--previous"
                onClick={decreaseMonth} 
                disabled={prevMonthButtonDisabled}>
              </button>
              <div className="react-datepicker__current-month">
                {`${getYear(date)}年${getMonth(date) + 1}月`}
              </div>
              <button 
                type="button" 
                className="react-datepicker__navigation react-datepicker__navigation--next"
                onClick={increaseMonth}
                disabled={nextMonthButtonDisabled}>
              </button>
            </div>
          )}
          {...otherProps}
          {...optionProps}
        />
        <button
          type='button'
          className='btn only-icon icon-input_calender'
          onClick={handleIconClick}
        />
      </div>
      {errors[name] && touched[name] ? (
        <p className={errorclasses.helperText}>{errors[name]}</p>
      ) : null}
    </FormControl>
  )
}
